import { RequestService } from "../../../../../common/services/RequestService";
import { GET_ORDER_SURCHARGE_PAYMENT } from "../constants";

export const getOrderSurchargePaymentRequest = async (orderId) => {
  const response = await RequestService.get(
    GET_ORDER_SURCHARGE_PAYMENT.replace("{order_id}", orderId)
  );
  return response;
};
